import React, { useContext, useState, useEffect } from 'react';
import { Card, Container, Form, Col, Row, Button, Alert } from 'react-bootstrap';
import { changeEmail, sendVerificationCode } from './change_email_logic';
import GroupButtonsForm from '../helpers_components/GroupSubmitFormButtons';
import LoaderContext from '../layout/shared/loader_context';
import OneColumn from '../layout/containers/OneColumn';
import Cookies from 'js-cookie';

const LOCK_KEY = 'changeEmailLock_v1';

const ChangeEmail = (props) => {
  const { uid_02 } = Cookies.get();
  const [oldEmailCode, setOldEmailCode] = useState('');
  const [showVerificationCode, setShowVerificationCode] = useState(false);
  const [hasSentCode, setHasSentCode] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [failedAttempts, setFailedAttempts] = useState(0);
  const [lockUntil, setLockUntil] = useState(0);
  const [lockRemaining, setLockRemaining] = useState(0);

  const [form, setForm] = useState({
    oldEmail: uid_02,
    newEmail: '',
    confirmEmail: '',
  });
  const [errors, setErrors] = useState({});
  const Loader = useContext(LoaderContext);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(LOCK_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (typeof parsed.failedAttempts === 'number') setFailedAttempts(parsed.failedAttempts);
      if (typeof parsed.lockUntil === 'number') setLockUntil(parsed.lockUntil);
    } catch (e) {
      console.error('Error loading lock state:', e);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCK_KEY, JSON.stringify({ failedAttempts, lockUntil }));
  }, [failedAttempts, lockUntil]);

  useEffect(() => {
    let interval = null;
    if (isButtonDisabled && timeRemaining > 0) {
      interval = setInterval(() => {
        setTimeRemaining((t) => {
          if (t <= 1) {
            setIsButtonDisabled(false);
            return 0;
          }
          return t - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isButtonDisabled, timeRemaining]);

  useEffect(() => {
    let interval = null;
    const tick = () => {
      const now = Date.now();
      if (lockUntil > now) {
        const sec = Math.ceil((lockUntil - now) / 1000);
        setLockRemaining(sec);
      } else {
        setLockRemaining(0);
        if (lockUntil !== 0) {
          setLockUntil(0);
          setFailedAttempts(0);
        }
      }
    };

    tick();
    interval = setInterval(tick, 1000);

    return () => clearInterval(interval);
  }, [lockUntil]);

  const isLocked = lockRemaining > 0;

  const onChangeHandler = (event) => {
    const { name, value } = event.target;

    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (name === 'newEmail') {
      if (!value.trim()) newErrors.newEmail = 'El nuevo correo electrónico es requerido';
      else if (!emailRegex.test(value)) newErrors.newEmail = 'Formato de correo inválido';
      else if (value === uid_02)
        newErrors.newEmail = 'El nuevo correo debe ser diferente al actual';
      else newErrors.newEmail = '';

      if (form.confirmEmail) {
        newErrors.confirmEmail =
          value === form.confirmEmail ? '' : 'Los correos electrónicos no coinciden';
      }
    }

    if (name === 'confirmEmail') {
      if (!value.trim())
        newErrors.confirmEmail = 'La confirmación del correo electrónico es requerida';
      else
        newErrors.confirmEmail =
          value === form.newEmail ? '' : 'Los correos electrónicos no coinciden';
    }

    if (name === 'oldEmailCode') {
      if (!value.trim()) newErrors.oldEmailCode = 'El código de verificación es requerido';
      else if (value.length < 4)
        newErrors.oldEmailCode = 'El código debe tener al menos 4 caracteres';
      else newErrors.oldEmailCode = '';
      setOldEmailCode(value);
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const preventCopyPaste = (event) => {
    event.preventDefault();
    return false;
  };

  const isSendCodeButtonEnabled = () => {
    return (
      form.newEmail.trim() !== '' &&
      form.confirmEmail.trim() !== '' &&
      !errors.newEmail &&
      !errors.confirmEmail &&
      form.newEmail === form.confirmEmail &&
      !isButtonDisabled &&
      !isLocked
    );
  };

  const handleSendCode = async () => {
    if (!isSendCodeButtonEnabled()) return;
    setShowVerificationCode(true);
    setHasSentCode(true);
    setIsButtonDisabled(true);
    setTimeRemaining(60);
    await sendVerificationCode(form.newEmail, form.oldEmail);
  };

  const getButtonText = () => {
    if (isButtonDisabled && timeRemaining > 0) return `Espera ${timeRemaining}s`;
    return hasSentCode ? 'Reenviar código' : 'Enviar código';
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (isLocked) return;
    Loader.show(true);
    const result = await changeEmail(form, oldEmailCode);
    Loader.show(false);
    if (!result.ok) {
      setFailedAttempts((prev) => {
        const next = prev + 1;
        if (next >= 3) {
          setLockUntil(Date.now() + 60 * 60 * 1000);
        }
        return next;
      });
      return;
    }
    setFailedAttempts(0);
    setLockUntil(0);
  };

  let pageConfig = { active: '', title: '' };

  const lockMinutes = Math.ceil(lockRemaining / 60);

  return (
    <OneColumn {...props} pageConfig={pageConfig} hideTopMenu={true} fluid={true} noTitle={true}>
      <Container
        fluid={true}
        className="bg-size-cover"
        style={{
          minHeight: '76vh',
          backgroundImage: 'url(' + process.env.PUBLIC_URL + '/img/líneas_izq.svg)',
        }}
      >
        <Container>
          <Row>
            <Col sm={12} md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }} className="mY-30">
              <Card className="mY-40@sm+">
                <Card.Header>
                  <Container>
                    <Row>
                      <Col
                        xs={12}
                        md={{ span: 10, offset: 1 }}
                        className="pT-20 pB-10 pT-30@sm+ pB-20@sm+"
                      >
                        <h3 className="mB-20 text-center">Actualizar Correo Electrónico</h3>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>

                <Card.Body>
                  {isLocked && (
                    <Alert variant="danger">
                      Has alcanzado el límite de intentos fallidos. Intenta de nuevo en{' '}
                      <b>{lockMinutes} min</b>.
                    </Alert>
                  )}

                  {!isLocked && failedAttempts > 0 && (
                    <Alert variant="warning">
                      Intentos fallidos: <b>{failedAttempts}</b> / 3
                    </Alert>
                  )}

                  <Form onSubmit={onSubmitHandler}>
                    <Form.Group controlId="formBasicOldPassword">
                      <Form.Label>
                        <b>Correo Electrónico Anterior</b>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        onChange={onChangeHandler}
                        name="oldPassword"
                        defaultValue={uid_02}
                        readOnly
                      />
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword">
                      <Form.Label className="d-flex justify-content-between align-items-center">
                        <b>* Nuevo correo electrónico</b>

                        <Button
                          size="sm"
                          onClick={handleSendCode}
                          disabled={!isSendCodeButtonEnabled()}
                          variant={
                            isButtonDisabled
                              ? 'warning'
                              : isSendCodeButtonEnabled()
                                ? 'primary'
                                : 'secondary'
                          }
                          style={{
                            color: isSendCodeButtonEnabled() ? '#ffffff' : '#495057',
                            fontWeight: isButtonDisabled ? 'bold' : 'normal',
                          }}
                        >
                          {getButtonText()}
                        </Button>
                      </Form.Label>

                      <Form.Control
                        type="email"
                        onChange={onChangeHandler}
                        name="newEmail"
                        value={form.newEmail}
                        autoComplete="off"
                        onCopy={preventCopyPaste}
                        onPaste={preventCopyPaste}
                        onCut={preventCopyPaste}
                        onDrop={preventCopyPaste}
                        onDragOver={preventCopyPaste}
                        className={errors.newEmail ? 'is-invalid' : ''}
                        disabled={isLocked}
                      />
                      {errors.newEmail && (
                        <small className="text-danger mt-2">{errors.newEmail}</small>
                      )}
                    </Form.Group>

                    <Form.Group controlId="formBasicConfirmEmail">
                      <Form.Label>
                        <b>* Confirmar nuevo correo electrónico</b>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        onChange={onChangeHandler}
                        name="confirmEmail"
                        value={form.confirmEmail}
                        autoComplete="off"
                        onCopy={preventCopyPaste}
                        onPaste={preventCopyPaste}
                        onCut={preventCopyPaste}
                        onDrop={preventCopyPaste}
                        onDragOver={preventCopyPaste}
                        className={errors.confirmEmail ? 'is-invalid' : ''}
                        disabled={isLocked}
                      />
                      {errors.confirmEmail && (
                        <small className="text-danger mt-2">{errors.confirmEmail}</small>
                      )}
                    </Form.Group>

                    {showVerificationCode && (
                      <Form.Group controlId="formBasicOldPasswordCode">
                        <Form.Label>
                          <b>* Código de verificación</b>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          onChange={onChangeHandler}
                          name="oldEmailCode"
                          value={oldEmailCode}
                          autoComplete="off"
                          className={errors.oldEmailCode ? 'is-invalid' : ''}
                          disabled={isLocked}
                        />
                        {errors.oldEmailCode && (
                          <small className="text-danger mt-2">{errors.oldEmailCode}</small>
                        )}
                      </Form.Group>
                    )}

                    <div className="pY-20">
                      <GroupButtonsForm
                        primaryText="Confirmar"
                        secondaryText="Cancelar"
                        urlToCancel="/home"
                        disabled={
                          isLocked ||
                          Object.values(errors).some((error) => error !== '') ||
                          !form.newEmail ||
                          !form.confirmEmail ||
                          !showVerificationCode ||
                          !oldEmailCode.trim()
                        }
                      />
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
    </OneColumn>
  );
};

export default ChangeEmail;
